// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Import server Config
import apiLink from '@configs/serverConfig'

// ** Axios Imports
import axios from 'axios'

// ** Rent
export const getStationsList = createAsyncThunk('appStations/getStationsList', async params => {
    params.page = params.page === 0 ? 0 : params.page - 1    
    const response = await axios.post(apiLink('getStations'), params)    
    
    return {
        params,
        data: response.data.content,
        totalPages: response.data.totalElements
    }
})
export const addStation = createAsyncThunk('appStations/addStation', async (data) => {
    const response = await axios.post(apiLink('addStation'), data)
    return response.data
})
export const updateStation = createAsyncThunk('appStations/updateStation', async (data) => {
    const response = await axios.put(apiLink({name: 'updateStation', value: data.id}), data)
    return response.data
})
export const getStation = createAsyncThunk('appStations/getStation', async (id) => {
    const response = await axios.get(apiLink({name: 'getStation', value: id}))
    return response.data
})
export const removeStation = createAsyncThunk('appStations/removeStation', async (id) => {
    const response = await axios.delete(apiLink({name: 'removeStation', value: id}))
    return response.data
})

export const appStationsSlice = createSlice({
    name: 'appStations',
    initialState: {
        stations: [],    
        total: 1,
        params: {},
        settings: [],
        selectedStation: null
    },
    reducers: {},
    extraReducers: builder => {
        builder
        .addCase(getStationsList.fulfilled, (state, action) => {
            state.stations = action.payload.data
            state.params = action.payload.params
            state.total = action.payload.totalPages
        })            
    }
})

export default appStationsSlice.reducer
